export const defaultPassword = "123123";
// export const API_BASE_URL = "http://localhost:5000";
export const API_BASE_URL = "https://backend.masari.me"
export const CALCULATED_WIDTH = "calc(90vw - 10vw - 20px)";
